<template lang='pug'>
  #homepage.c-content(@click="closePopup")
    MenuTop(ref="whdmenu")
    .c-whdBanner
      img(:src="img.whd_mini" alt="whd_soundpricture_mini")
    .c-whdNav
      .c-whdNavItems
        .c-whdNavItem(v-for="(item, index) in navs" :key="index" :class="{'is-active': $route.name == item.url} " @click="routeTo(item.url)") {{ item.name }}
    
    .c-section(v-for="(item, index) in sections" :key="index")
      .c-whdImage(v-if="item.type == 'image'")
        img(:src="item.image" alt="")
        a.c-whdImage--button(v-if="item.buttons" v-for="(b, k) in item.buttons" :key="k" :style="{width: b.width, height: b.height, top: b.top, left: b.left}" :href="b.url || 'javascript:void(0)'" @click="!b.url && handleNoUrlClick(b)" target="_blank")
      .c-whdVideo(v-else-if="item.type == 'video'")
        .c-whdVideo--title {{ item.title }}
        video.block(:src="item.url" controls="controls" :poster="item.poster")
      .c-whdEmail(v-else-if="item.type == 'email'")
        .c-whdEmail--block
          .col-12.col-m-24.c-whdEmail--block--left
            .c-whdEmail--title {{ $t('whd.email_title') }}
            .c-whdEmail--sub {{ $t('whd.email_sub') }}
            p.inlineBlock
              span {{ $t('whd.email_text_1') }}
              span.color-orange {{ $t('whd.email_text_2') }}
              span {{ $t('whd.email_text_3') }}
            p {{ $t('whd.email_text_4') }}
            p(style="margin-bottom: 0") {{ $t('whd.email_text_5') }}
            p.email {{ $t('whd.email_text_6') }}
          .col-12.col-m-24
            ContactForm
    Footer

</template>

<script>
  import MenuTop from '@/components/menu/whd_menu.vue'
  import ContactForm from '@/components/layout/content/whdContactForm.vue'
  import Footer from '@/components/footer/whd_footer.vue'

  export default {
    name: 'whd_homepage',
    components: {
      MenuTop,
      ContactForm,
      Footer,
    },
    data(){
      return {
        img: {
          whd_mini: require('@/assets/img/whd/whd_soundpicture_mini.png')
        },
        navs: [
          { name: this.$t('whd.nav_1'), url: 'whd_homepage' },
          { name: this.$t('whd.nav_2'), url: 'whd_business' },
          { name: this.$t('whd.nav_3'), url: 'whd_customer' },
        ],
        sections: [
          {
            type: 'image',
            image: require('@/assets/img/whd/homepage_01.jpg'), 
            buttons: [
              {width: '35%', height: '3.5vw', left: '19.2%', top: '77%', url: '', },
            ]
          }, 
          { type: 'video', title: this.$t('whd.video_title'), url: require('@/assets/img/whd/SP-mini.mp4')},
          {
            type: 'image',
            image: require('@/assets/img/whd/homepage_02.jpg'), 
            buttons: [
              {width: '29.5%', height: '3.5vw', left: '19.2%', top: '82.7%', url: '', },
            ] 
          },
          {
            type: 'image',
            image: require('@/assets/img/whd/homepage_03.jpg'), 
            buttons: [
              {width: '27%', height: '3.5vw', left: '56.2%', top: '37.45%', url: '', },
              {width: '26.9%', height: '3.5vw', left: '37.6%', top: '57.5%', url: '', },
              {width: '26.9%', height: '3.5vw', left: '36.6%', top: '94.7%', url: '', },
            ] 
          },
          {
            type: 'image',
            image: require('@/assets/img/whd/homepage_04.jpg'), 
            buttons: [
              {width: '35.3%', height: '3.5vw', left: '32.4%', top: '23.9%', url: '', },
              {width: '35.3%', height: '3.5vw', left: '32.4%', top: '51.7%', url: '', },
              {width: '22.2%', height: '3.5vw', left: '38.9%', top: '94.3%', url: '', },
            ] 
          },
          {
            type: 'image',
            image: require('@/assets/img/whd/homepage_05.jpg'), 
            buttons: [
              {width: '22%', height: '3.5vw', left: '39.4%', top: '30.3%', url: '', },
              {width: '19.2%', height: '3.5vw', left: '18.9%', top: '90.4%', url: 'https://whd.de/', },
              {width: '19.2%', height: '3.5vw', left: '41%', top: '90.4%', url: 'https://whd.de/pages/ueber-whd', },
              {width: '19.2%', height: '3.5vw', left: '62.6%', top: '90.4%', url: 'https://whd.de/pages/referenzen-ubersicht', },
            ] 
          },
          { type: 'email', },
          {
            type: 'image',
            image: require('@/assets/img/whd/homepage_06.jpg'),
          },
        ],
      }
    },
    methods: {
      routeTo(link, index){
        if(link == this.$route.name) return
        this.$router.push({
          name: link,
          query: {
            id: index
          }
        })
      },
      handleNoUrlClick(b){
        event.preventDefault();
      },
      closePopup(){
        if (this.$refs.whdmenu && this.$refs.whdmenu.languageActive && this.$refs.whdmenu.languageActive == true) {
          this.$refs.whdmenu.closeLanguageChild()
        }
      }
    },
  }
</script>
